import { BrowserRouter, Route, Routes} from "react-router-dom";
import { useEffect, useState } from 'react';
import axios from 'axios';
import HomePage from './HomePage';
import AdminPage from './AdminPage';
import LoginPage from './LoginPage';
import RegisterPage from './RegisterPage';
import ShopPage from "./ShopPage";
import ProductPage from './ProductPage';
import CartPage from "./CartPage";
import CheckoutPage from "./CheckoutPage";
import QuizPage from './QuizPage';
import OrdersPage from './OrdersPage';
import PrivateRoute from './PrivateRoute';

axios.defaults.baseURL = 'https://moodmeals.onrender.com';
axios.defaults.withCredentials = true;

const AppController=()=>{

    const [user,setUser]=useState(null);
    const [cart, setCart]=useState([]);
    const [orderSummary,setOrderSummary]=useState({});
    const [isLoggedIn,setIsLoggedIn]=useState(false);
    const [logoutSuccess,setLogoutSuccess]=useState(false);

    useEffect(() => {
        const checkSession = async () => {
            try {
                const sessionRes = await axios.get('/api/session');
                setUser(sessionRes.data.user);
                setIsLoggedIn(true);
                const cartRes = await axios.get('/api/user/getCartItems');
                setCart(cartRes.data.cart);
            } catch (err) {
                setIsLoggedIn(false);
                setUser(null);
                setCart([]);
            }
        };
        checkSession();
    }, [isLoggedIn, logoutSuccess]);

    const handleLogout=()=>{
        axios.get('/api/users/logout')
        .then(res=>{
            setUser(null);
            setIsLoggedIn(false);
            setLogoutSuccess(true);
        })
        .catch(err=>{
            console.error('Error logging out:',err);
        });
    };

    const myProps={
        user,
        onLogout: handleLogout,
        logoutSuccess,
        setLogoutSuccess,
        cart,
        setCart,
        orderSummary,
        setOrderSummary
    };

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage {...myProps}/>}></Route>
                <Route path="/admin" element={<PrivateRoute isAuth={isLoggedIn}><AdminPage {...myProps}/></PrivateRoute>}></Route>
                <Route path="/quiz" element={<PrivateRoute isAuth={isLoggedIn}><QuizPage {...myProps}/></PrivateRoute>}></Route>
                <Route path="/login" element={<LoginPage setIsLoggedIn={setIsLoggedIn}/>}></Route>
                <Route path="/register" element={<RegisterPage {...myProps}/>}></Route>
                <Route path="/shop" element={<ShopPage {...myProps}/>}></Route>
                <Route path="/:name/:id" element={<ProductPage {...myProps}/>}></Route>
                <Route path="/your-cart" element={<PrivateRoute isAuth={isLoggedIn}><CartPage {...myProps} /></PrivateRoute>}></Route>
                <Route path="/checkout" element={<PrivateRoute isAuth={isLoggedIn}><CheckoutPage {...myProps}/></PrivateRoute>}></Route>
                <Route path="/your-orders" element={<PrivateRoute isAuth={isLoggedIn}><OrdersPage {...myProps}/></PrivateRoute>}></Route>
            </Routes>
        </BrowserRouter>
    )
}

export default AppController;
